import React from 'react';
import { useTranslation } from 'react-i18next';
import Badge, { BadgeType } from 'src/components/ui/Badge/Badge';
import Button, { ButtonToneProps } from '../../ui/Button/Button';
import Icon, { IconName } from '../../ui/Icon/Icon';
import './AddOnsCard.scss';

export interface AddOnsCardProps {
  title: string;
  description: string;
  price: string;
  icon?: IconName;
  url?: string;
  active?: boolean;
  billingCycle?: 'month' | 'year';
}

const AddOnsCard: React.FC<AddOnsCardProps> = ({
  title,
  description,
  price,
  icon = 'store',
  url,
  active,
  billingCycle = 'month',
}) => {
  const { t } = useTranslation();

  return (
    <div className={`addOnsCard rounded-base border-subtle ${active ? 'surface-base' : 'surface-elevated'}`}>
      <div className="flex items-center justify-between p-20">
        <div className="flex items-center flex-1">
          <div className="flex-shrink-0 mr-16">
            <Icon name={icon} width={24} height={24} className="text-faded" />
          </div>
          <div className="flex-1">
            <div className="flex gap-6 mb-4">
              <h3 className="typo-text-14--bold text-full">{title}</h3>
              {active && <Badge label={t('add_ons_billing.subscribed')} expanded type={BadgeType.Neutral4} />}
            </div>
            <p className="typo-text-12 text-faded">{description}</p>
          </div>
        </div>
        <div className="flex items-center ml-16">
          <div className="typo-text-16--bold text-full mr-16 flex flex-col gap-4 items-end">
            <p>
              {price} <span className="typo-text-12">{t('add_ons_billing.per_month')}</span>
            </p>
            {active && (
              <span className="typo-text-12 text-faded">
                {t(`add_ons_billing.cycle_${billingCycle.toLowerCase()}`)}
              </span>
            )}
          </div>
          {!active && (
            <Button
              tone={ButtonToneProps.PRIMARY_BLUE}
              title="Upgrade"
              onClick={() => window.open(url, '_blank')}
              className="whitespace-nowrap"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default AddOnsCard;
